import * as Yup from 'yup'
import { createValidation } from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const anotacaoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    anotacao: Yup.string().trim().required(v.requiredField('observacao')),
  })
}
